import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Textbox } from './../../models/editors/textbox.model';

import { HomeTile } from './../../models/hometiles/hometiles.model';

import { ApiService } from './../../shared/services/api.service';
import { FormControlService } from './../../shared/services/form-control.service';
import { AlertService } from './../../shared/services/alert.service';
import { Dropdown } from './../../models/editors/dropdown.model';
import { Page } from './../../models/pages/pages.model';
import { Contained } from './../../models/editors/contained.model';
import { FormDetailBase } from './../../shared/components/base/form-detail/form-detail.base.component';
import { atLeastOneLang } from './../../shared/validators/langField.validator';
import { FormEditor } from './../../models/editors/form-editor.base.model';
import { Textarea } from './../../models/editors/textarea.model';
@Component({
  selector: 'swb-hometile-detail',
  templateUrl: './../../shared/components/base/form-detail/form-detail.base.component.html',
  providers: [FormControlService]
})
export class HomeTileDetailComponent extends FormDetailBase<HomeTile> implements OnInit {
  public url = 'home-tiles';
  protected _redirect = './homepage';

  public entity = new HomeTile({});
  public pages: Array<Page> = [];

  public get fieldsConfig(): Array<FormEditor<any>> {
    return [
      new Textbox({
        key: 'title',
        label: 'Nadpis dlaždice',
        validators: [atLeastOneLang],
        isMultilang: true
      }),
      new Textarea({
        key: 'content',
        label: 'Text dlaždice',
        validators: [],
        isMultilang: true
      }),
      new Dropdown({
        key: 'page_id',
        label: 'Stránka, na kterou odkazuje',
        validators: [],
        isMultilang: false,
        options: this._formService.getDropdownValues('title', this.pages)
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _router: Router,
    _alertService: AlertService,
    private _route: ActivatedRoute
  ) {
    super(
      _formService,
      _apiService,
      _router,
      _alertService
    );
  }

  ngOnInit() {
    if (typeof this._route.snapshot.params['id'] !== 'undefined') {
      this._id = this._route.snapshot.params['id'];
    }
    this._getPagesList();

  }

  private _getPagesList() {
    this._apiService.get('pages/list')
      .subscribe(
        (response: any) => {
          this.pages = { ...response }.data;
          this._getEntity();
        },
        (error) => console.error(error)
      );
  }
}
